export default "/cross-chain.d93908b9a933302baeb9f2407eeb0cdd.png";